import { Box, Button, FormControl, FormLabel, Input, Text } from '@chakra-ui/react'

export type SearchOption = {
  value: number
  label: string
  hint?: string
}

type Props = {
  label: string
  placeholder: string
  query: string
  options: SearchOption[]
  selectedValue: number | null
  loading?: boolean
  emptyText?: string
  onQueryChange: (query: string) => void
  onSelect: (value: number) => void
}

export function SearchableOptions({
  label,
  placeholder,
  query,
  options,
  selectedValue,
  loading,
  emptyText,
  onQueryChange,
  onSelect,
}: Props) {
  return (
    <FormControl>
      <FormLabel>{label}</FormLabel>
      <Input
        value={query}
        placeholder={placeholder}
        onChange={(event) => onQueryChange(event.target.value)}
      />
      <Box mt={1} borderWidth="1px" borderRadius="md" maxH="220px" overflowY="auto">
        {loading ? (
          <Text fontSize="sm" p={2}>
            Searching…
          </Text>
        ) : options.length === 0 ? (
          <Text fontSize="sm" p={2} color="gray.500">
            {emptyText || 'No matches'}
          </Text>
        ) : (
          options.map((option) => (
            <Button
              key={option.value}
              variant={option.value === selectedValue ? 'solid' : 'ghost'}
              colorScheme={option.value === selectedValue ? 'blue' : undefined}
              justifyContent="flex-start"
              width="100%"
              height="auto"
              whiteSpace="normal"
              textAlign="left"
              py={2}
              borderRadius={0}
              onClick={() => onSelect(option.value)}
            >
              <Box>
                <Text fontSize="sm">{option.label}</Text>
                {option.hint ? (
                  <Text fontSize="xs" color={option.value === selectedValue ? 'whiteAlpha.800' : 'gray.500'}>
                    {option.hint}
                  </Text>
                ) : null}
              </Box>
            </Button>
          ))
        )}
      </Box>
    </FormControl>
  )
}
